<script setup>
defineProps({
  content: { type: Object, required: true },
  variant: { type: String, default: 'hero-01' },
})
</script>

<template>
  <section class="b2-hero" :class="`variant-${variant}`">
    <video class="b2-hero-video" autoplay muted loop playsinline>
      <source :src="content.hero_video_url.value" type="video/mp4" />
    </video>
    <div class="b2-hero-overlay">
      <p class="b2-hero-kicker">{{ content.hero_kicker.value }}</p>
      <h1 class="b2-hero-headline">{{ content.hero_headline.value }}</h1>
      <p class="b2-hero-sub">{{ content.hero_sub.value }}</p>
      <div class="b2-hero-buttons">
        <a href="#services" class="b2-btn-primary">{{ content.hero_btn_1.value }}</a>
        <a href="#contact" class="b2-btn-outline">{{ content.hero_btn_2.value }}</a>
      </div>
    </div>
  </section>
</template>

<style scoped>
.b2-hero { position: relative; min-height: 70vh; overflow: hidden; display: flex; align-items: center; justify-content: center; }
.b2-hero-video { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: cover; filter: brightness(.55) saturate(1.2); }
.b2-hero-overlay { position: relative; z-index: 2; text-align: center; color: white; padding: 60px 20px; max-width: 860px; }
.b2-hero-kicker { font-size: 12px; font-weight: 500; letter-spacing: .2em; text-transform: uppercase; color: #8fcf7e; margin-bottom: 20px; }
.b2-hero-headline { font-family: 'Playfair Display', serif; font-size: clamp(36px, 6vw, 72px); font-weight: 700; line-height: 1.05; margin-bottom: 20px; }
.b2-hero-sub { font-size: 18px; font-weight: 300; opacity: .85; max-width: 520px; margin: 0 auto 36px; line-height: 1.6; }
.b2-hero-buttons { display: flex; gap: 16px; justify-content: center; flex-wrap: wrap; }
.b2-btn-primary { background: #4a8c3f; color: white; padding: 14px 32px; border-radius: 2px; text-decoration: none; font-size: 14px; font-weight: 500; letter-spacing: .06em; text-transform: uppercase; border: none; cursor: pointer; transition: background .2s, transform .15s; display: inline-block; }
.b2-btn-primary:hover { background: #3a6e30; transform: translateY(-1px); }
.b2-btn-outline { background: transparent; color: white; border: 1.5px solid rgba(255,255,255,.6); padding: 14px 32px; border-radius: 2px; text-decoration: none; font-size: 14px; font-weight: 500; letter-spacing: .06em; text-transform: uppercase; transition: border-color .2s, background .2s; display: inline-block; }
.b2-btn-outline:hover { border-color: white; background: rgba(255,255,255,.1); }
.variant-hero-02 { justify-content: flex-start; min-height: 76vh; }
.variant-hero-02 .b2-hero-video { filter: brightness(.48) saturate(.85); }
.variant-hero-02 .b2-hero-overlay { max-width: 760px; padding: 90px max(40px, calc((100% - 1120px) / 2)); text-align: left; }
.variant-hero-02 .b2-hero-sub { margin-left: 0; }
.variant-hero-02 .b2-hero-buttons { justify-content: flex-start; }
.variant-hero-03 { min-height: 74vh; justify-content: flex-end; align-items: flex-end; }
.variant-hero-03 .b2-hero-video { filter: brightness(.7) saturate(1.1); }
.variant-hero-03 .b2-hero-overlay { width: min(620px, calc(100% - 48px)); margin: 0 4vw 4vw 0; padding: 44px; background: rgba(15,31,19,.92); text-align: left; border-left: 5px solid #8fcf7e; }
.variant-hero-03 .b2-hero-sub { margin-left: 0; }
.variant-hero-03 .b2-hero-buttons { justify-content: flex-start; }
@media (max-width: 600px) {
  .variant-hero-02 .b2-hero-overlay { padding: 64px 24px; }
  .variant-hero-03 .b2-hero-overlay { width: calc(100% - 32px); margin: 16px; padding: 30px 24px; }
}
</style>
